
import Vue from 'vue';
import Vuetify from 'vuetify';
import FormularioHomeModal from '../components/index/FormularioHomeModal.vue'

Vue.use(Vuetify);

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select-c', vSelect);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

Vue.config.productionTip = false;
Vue.config.devtools = true;

if (document.getElementById("formulario-home-modal")) {
    new Vue({
        el: '#formulario-home-modal',
        components: {
            FormularioHomeModal
        },
        vuetify: new Vuetify(),
    });
}